import api from '@/api'

const { $pricing, $qSystem } = api;

export const { $statements } = $qSystem;
export const { $types } = $pricing;

